import { action } from 'typesafe-actions';
import { Props } from './index';
export const ACTIVATE = 'IDEA_LANDING/ACTIVATE';
export const DEACTIVATE = 'IDEA_LANDING/DEACTIVATE';

export const lifecycle = {
  activate: (props: Props) => action(ACTIVATE, props),
  deactivate: () => action(DEACTIVATE),
};
